<template>
	<div class="home">
		<section class="top-section">
			<h2>
				code. travel. learn. 
			</h2>
			<p>
				Welcome! The <b><i>latest updates</i></b> section will have all the most up to date news about the site. 
				<br>Feel free to let me know your thoughts about the site by clicking on the exclamation icon in the bottom right 
				corner. 
			</p>
		</section>
		<div class="container">
			<div class="column column-left">
				<h4>this section is still a work in progress</h4>
			</div>
			<div class="column column-center">
				<iframe v-if="false" class="resume" src="https://docs.google.com/document/d/e/2PACX-1vSyGXE_QqwzylqIxjWf0N27Vy_6Ag5adnS5sopdhpEeWk8h5E8lEC5HbBHqwLPomKoBuZdH--uHUsJu/pub?embedded=true"></iframe>
				<h4 v-else >this section is still a work in progress</h4>
			</div>
			<div class="column column-right">
				<Updates />
			</div>
		</div>
	</div>
</template>

<script>
import { computed } from 'vue';
import { useStore } from 'vuex'
import Updates from '../components/Updates';

export default {
	name: 'Home',
	components: {
		Updates
	},
	setup() {
		const store = useStore();

		const userInfo = computed(() => store.state.userInfo);

		return {
			userInfo
		}
	}
}
</script>

<style scoped>

h4 {
	width: 90%;
}

.resume {
	width: 90%;
	height: 500pt;
}

.container {
	display: flex;
	justify-content: center;
	align-items: center;
	margin: 20pt;
}

.column {
	margin: 5pt;
	border: 1pt solid white;
	border-radius: 10pt;
}

.column-left, .column-right{
	flex: 25%;
}

.column-center {
	flex: 50%;
	border: 1pt solid white;
}

.top-section {
	margin: 40pt 20pt
}

@media (max-width: 1000pt) {
	.container {
		flex-direction: column;
	}
}

</style>